import { toast } from "react-hot-toast";
import { apiConnector } from "../apiConnector";
import { documentAnalysisEndpoints } from "../apis";

const { ANALYZE_DOCUMENT_API, ANALYSIS_HISTORY_API } = documentAnalysisEndpoints;

const getAuthHeader = () => ({
  Authorization: `Bearer ${JSON.parse(localStorage.getItem("token"))}`,
});

// Upload a document/image and get the AI analysis
export async function analyzeDocument({ file, note }) {
  try {
    const formData = new FormData();
    formData.append("document", file);
    if (note) formData.append("note", note);

    const response = await apiConnector("POST", ANALYZE_DOCUMENT_API, formData, {
      ...getAuthHeader(),
      "Content-Type": "multipart/form-data",
    });

    if (!response.data.success) throw new Error(response.data.message);

    return response.data.data;
  } catch (error) {
    console.error("Failed to analyze document", error);
    toast.error(
      error?.response?.data?.message ||
        error.message ||
        "Failed to analyze document"
    );
    return null;
  }
}

// Fetch the logged-in user's past analyses
export async function getAnalysisHistory() {
  try {
    const response = await apiConnector(
      "GET",
      ANALYSIS_HISTORY_API,
      null,
      getAuthHeader()
    );

    if (!response.data.success) throw new Error(response.data.message);

    return response.data.data;
  } catch (error) {
    console.error("Failed to fetch analysis history", error);
    return [];
  }
}
